<script>
  import Input from '@components/Input.svelte';
  import { createEventDispatcher } from 'svelte';

  export let value;
  export let error;

  let shown = false;
  let focused = false;

  $: inputType = shown ? 'text' : 'password';

  let showHideImagePath;
  $: {
    let fileName;
    if (shown) {
      fileName = focused ? 'eye-hide-gray.svg' : 'eye-hide-purple.svg';
    } else {
      fileName = focused ? 'eye-show-gray.svg' : 'eye-show-purple.svg';
    }
    showHideImagePath = `/images/password-input/${fileName}`;
  }

  const dispatch = createEventDispatcher();

  export const checkIfValid = () => {};

  const onFocus = () => {
    focused = true;
  };

  const onBlur = () => {
    focused = false;
    checkIfValid();
  };

  const onEnter = () => {
    checkIfValid();
  };

  const toggleVisibility = () => {
    shown = !shown;
  };
</script>

<style style="text/scss" lang="scss">
</style>

<div>
  <Input
    type={inputType}
    error={error || undefined}
    rightIconPath={showHideImagePath}
    bind:value={value}
    {...$$restProps}
    on:click={(e) => {
      dispatch('click', e.detail);
    }}
    on:focus={(e) => {
      onFocus();
      dispatch('focus', e.detail);
    }}
    on:keydown={(e) => {
      dispatch('keydown', e.detail);
    }}
    on:keyup={(e) => {
      if (e.detail.which === 13) {
        onEnter();
      }

      dispatch('keyup', e.detail);
    }}
    on:change={(e) => {
      dispatch('change', e.detail);
    }}
    on:blur={(e) => {
      onBlur();
      dispatch('blur', e.detail);
    }}
    on:mounted={(e) => {
      dispatch('mounted', e.detail);
    }}
    on:right-icon-click={(_e) => {
      toggleVisibility();
    }} />
</div>
